"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var DragIndicator_1 = __importDefault(require("@mui/icons-material/DragIndicator"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var CrudeTextInputTrash_1 = __importDefault(require("../../../screens/DataEditView/FormComponents/utils/CrudeTextInputTrash"));
var react_i18next_1 = require("react-i18next");
var CrudeCreateTextFieldDialog_1 = __importDefault(require("../../../screens/DataEditView/FormComponents/utils/CrudeCreateTextFieldDialog"));
var isJsonString_1 = __importDefault(require("../../../shared/util/isJsonString"));
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var CrudeJsonComponent = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var t = react_i18next_1.useTranslation().t;
    var theme = material_1.useTheme();
    var entity = props.entity;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    // manage Licenses
    var freeJSONLicense = crudeLicense.freeJSON.available;
    var columnName = props.schema.name;
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var jsonObject = {};
    if (isJsonString_1.default(props.data.data[columnName])) {
        jsonObject = JSON.parse(props.data.data[columnName]);
    }
    var _g = react_1.useState(false), openDialog = _g[0], setOpenDialog = _g[1];
    var _h = react_1.useState(), dragged = _h[0], setDragged = _h[1];
    var _j = react_1.useState(), over = _j[0], setOver = _j[1];
    var _k = react_1.useState([]), dragList = _k[0], setDragList = _k[1];
    react_1.useEffect(function () {
        var obj = {};
        if (isJsonString_1.default(props.data.data[columnName])) {
            obj = JSON.parse(props.data.data[columnName]);
        }
        var jsonArray = [];
        obj && Object.keys(obj).map(function (key) {
            jsonArray.push({
                key: key,
                value: obj[key] || '',
            });
        });
        setDragList(jsonArray);
    }, [props.data]);
    var onChangeJsonObject = function (obj) {
        var newData = props.data;
        var jsonArray = [];
        Object.keys(obj).map(function (key) {
            jsonArray.push({
                key: key,
                value: obj[key],
            });
        });
        setDragList(jsonArray);
        var newColumnData = newData.data;
        newColumnData[columnName] = JSON.stringify(obj);
        newData.data = newColumnData;
        props.onChange && props.onChange(newData);
    };
    var disabled = props.disabled ? props.disabled : false;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Typography, { variant: 'button', sx: { mb: 2 }, style: { display: 'flex' } },
            react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description })),
        react_1.default.createElement("ul", { style: {
                listStyleType: 'none',
                padding: 0,
                margin: 0,
            } }, dragList.length > 0 && dragList.map(function (data, i) {
            var _a;
            var jsonData = data;
            return (react_1.default.createElement("li", { className: 'dragElement', style: { margin: '15px 0' }, "data-id": i, key: i, draggable: freeJSONLicense, onDragStart: function (e) {
                    setDragged(e.currentTarget);
                    e.dataTransfer.effectAllowed = 'move';
                }, onDragOver: function (event) {
                    if (dragged) {
                        dragged.style.opacity = '0.5';
                    }
                    setOver(Number(event.currentTarget.dataset.id));
                }, onDragEnd: function (e) {
                    var from = Number(dragged ? dragged.dataset.id : 0);
                    var to = over || 1;
                    if (from >= to) {
                        to = to - 1;
                    }
                    var dragElem = dragList[from];
                    var data = [];
                    dragList.map(function (elem, index) {
                        if (index === to && to === 0) {
                            data.push(dragElem);
                        }
                        if (index !== from) {
                            data.push(elem);
                        }
                        if (index === to && to !== 0) {
                            data.push(dragElem);
                        }
                    });
                    setDragList(data);
                    var newObject = {};
                    data.map(function (elem) {
                        newObject[elem.key] = elem.value;
                    });
                    jsonObject = newObject;
                    onChangeJsonObject(jsonObject);
                    if (dragged) {
                        dragged.style.opacity = '1';
                    }
                } },
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center' } },
                    freeJSONLicense && react_1.default.createElement(DragIndicator_1.default, { sx: { width: '20px' } }),
                    react_1.default.createElement(material_1.TextField, { "data-id": i, name: jsonData.key, key: i + "-field", InputLabelProps: { shrink: true }, value: jsonData.value, label: jsonData.key, onChange: function (event) {
                            jsonObject[jsonData.key] = event.target.value;
                            onChangeJsonObject(jsonObject);
                        }, sx: {
                            width: props.fullWidth ? 'calc(100% - 20px)' : '280px',
                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: theme.palette.primary.main,
                                borderWidth: 2,
                            },
                        }, margin: 'none', variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type, InputProps: {
                            readOnly: disabled,
                            disabled: disabled,
                            endAdornment: (react_1.default.createElement(CrudeTextInputTrash_1.default, { onTrashClick: function (event) {
                                    delete jsonObject[jsonData.key];
                                    onChangeJsonObject(jsonObject);
                                } })),
                        }, autoFocus: false }))));
        })),
        !disabled && freeJSONLicense &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Button, { style: { width: props.fullWidth ? '100%' : '300px' }, variant: (_f = appLayout === null || appLayout === void 0 ? void 0 : appLayout.button) === null || _f === void 0 ? void 0 : _f.type, color: 'primary', startIcon: react_1.default.createElement(Add_1.default, null), onClick: function () {
                        setOpenDialog(true);
                    } }, t('crude:createOwnTextField')),
                react_1.default.createElement(CrudeCreateTextFieldDialog_1.default, { open: openDialog, json: jsonObject, column: columnName, openDialog: setOpenDialog, onChangeJson: onChangeJsonObject }))));
};
exports.default = CrudeJsonComponent;
